import React, { useEffect } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { initMetaPixel } from '../lib/metaPixel';
import { Hero } from '../components/Hero';
import { ProofStrip } from '../components/ProofStrip';
import { Testimonials } from '../components/Testimonials';
import { PainPoints } from '../components/PainPoints';
import { ForWhom } from '../components/ForWhom';
import { StatsStrip } from '../components/StatsStrip';
import { Tomos } from '../components/Tomos';
import { Bonos } from '../components/Bonos';
import { VsTable } from '../components/VsTable';
import { UrgencyBanner } from '../components/UrgencyBanner';
import { Pricing } from '../components/Pricing';
import { ProEliteExplainer } from '../components/ProEliteExplainer';
import { Guarantee } from '../components/Guarantee';
import { Faq } from '../components/Faq';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
import { MobileStickyCta } from '../components/MobileStickyCta';
import { PurchaseNotification } from '../components/PurchaseNotification';
export function Landing() {
  // Shared 6-hour urgency timer used by both UrgencyBanner instances
  const urgency = useCountdown(21600);
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-363">
      <Hero data-id="element-364" />
      <ProofStrip data-id="element-365" />
      <Testimonials data-id="element-366" />
      <PainPoints data-id="element-367" />
      <ForWhom data-id="element-368" />
      <StatsStrip data-id="element-369" />
      <Tomos data-id="element-370" />
      <Bonos data-id="element-371" />
      <VsTable data-id="element-372" />
      <UrgencyBanner hours={urgency.hours} minutes={urgency.minutes} seconds={urgency.seconds} data-id="element-373" />
      <Pricing data-id="element-374" />
      <ProEliteExplainer data-id="element-375" />
      <Guarantee data-id="element-376" />
      <Faq data-id="element-377" />
      <UrgencyBanner hours={urgency.hours} minutes={urgency.minutes} seconds={urgency.seconds} data-id="element-378" />
      <FinalCta data-id="element-379" />
      <Footer data-id="element-380" />
      <MobileStickyCta data-id="element-381" />
      <PurchaseNotification data-id="element-382" />
    </div>;
}